import numeral from 'numeral';

export default text => numeral(text).value();



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/getValue.js